import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminProductLandings from "@/pages/admin/AdminProductLandings";

export const Route = createFileRoute("/admin/product-landings/")({
  component: () => (
    <ProtectedRoute>
      <AdminProductLandings />
    </ProtectedRoute>
  ),
});
